import PurchasesApi from "../../apis/Purchases";

import ArrayTools from "../../helpers/ArrayTools";

export default {
  namespaced: true,
  state: {
    purchase: null,
    supplier_id: null,
    register_date: null,
    register_date_emision: null,
    tipo_cambio: null,
    tipo_moneda: null,
    sale_order: null,
    type_document: null,
    serie: null,
    correlative: null,
    credit_purchase: false,
    date_payment: null,
    purchase_detail: [],
    subtotal: null,
    discount: null,
    igv: null,
    total: null,
    type_operation: "create",
    purchase_id: null,
    storehouse_id: null,
    origin_id: null,
    account_id: null,
    till_id: null,
  },
  mutations: {
    set_supplier_id(state, supplier_id) {
      state.supplier_id = supplier_id;
    },
    set_register_date(state, register_date) {
      state.register_date = register_date;
    },
    set_register_date_emision(state, register_date_emision) {
      state.register_date_emision = register_date_emision;
    },
    set_tipo_cambio(state, tipo_cambio) {
      state.tipo_cambio = tipo_cambio;
    },
    set_tipo_moneda(state, tipo_moneda) {
      state.tipo_moneda = tipo_moneda;
    },
    set_sale_order(state, sale_order) {
      state.sale_order = sale_order;
    },
    set_type_document(state, value) {
      state.type_document = value;
    },
    set_serie(state, serie) {
      state.serie = serie;
    },
    set_correlative(state, correlative) {
      state.correlative = correlative;
    },
    set_purchase(state, purchase) {
      state.purchase = purchase;
    },
    set_credit_purchase(state, value) {
      state.credit_purchase = value;
    },
    set_date_payment(state, value) {
      state.date_payment = value;
    },
    set_purchase_detail(state, data) {
      state.purchase_detail = data;
    },
    add_item_purchase_detail(state, item) {
      state.purchase_detail.push(item);
    },
    remove_item_purchase_detail(state, index) {
      state.purchase_detail.splice(index, 1);
    },
    replace_item_purchase_detail(state, data) {
      state.purchase_detail.splice(data.index, 1, data.item);
    },
    set_subtotal(state, value) {
      state.subtotal = value;
    },
    set_discount(state, value) {
      state.discount = value;
    },
    set_igv(state, value) {
      state.igv = value;
    },
    set_total(state, value) {
      state.total = value;
    },
    set_type_operation(state, value) {
      state.type_operation = value;
    },
    set_purchase_id(state, value) {
      state.purchase_id = value;
    },
    set_storehouse_id(state, value) {
      state.storehouse_id = value;
    },
    set_origin_id(state, origin_id) {
      state.origin_id = origin_id;
    },
    set_account_id(state, account_id) {
      state.account_id = account_id;
    },
    set_till_id(state, till_id) {
      state.till_id = till_id;
    },
    set_clean_data(state){
      // ! resetear del vuex
      state.purchase_id = null
      state.supplier_id =null
      state.register_date =null
      state.register_date_emision = null
      state.tipo_cambio = null
      state.tipo_moneda = null
      state.sale_order = null
      state.credit_purchase =false
      state.type_document =null
      state.date_payment =null
      state.serie =null
      state.correlative = null
      state.storehouse_id =null
      state.origin_id = null
      state.till_id = null
      state.account_id =null
    },
    set_calculate_total_amount(state, data){
      state.subtotal = data.set_subtotal
      state.discount = data.set_discount
      state.igv = data.set_igv 
      state.total = data.set_total
    },
    set_select_purchase_to_edit(state, data){
      state.purchase_id = data.set_purchase_id
      state.supplier_id = data.set_supplier_id
      state.register_date =data.set_register_date
      state.register_date_emision =data.set_register_date_emision
      state.sale_order = data.set_sale_order
      state.credit_purchase = data.set_credit_purchase
      state.date_payment = data.set_date_payment
      state.type_document =data.set_type_document
      state.serie = data.set_serie
      state.correlative = data.set_correlative
      state.purchase_detail = data.set_purchase_detail
      state.subtotal = data.set_subtotal
      state.discount = data.set_discount
      state.igv = data.set_igv 
      state.total = data.set_total
      state.storehouse_id =  data.set_storehouse_id
      state.origin_id = data.set_origin_id
      state.account_id =data.set_account_id
      state.till_id = data.set_till_id
    }
  },
  actions: {
    set_type_operation({ commit }, value) {
      commit("set_type_operation", value);
    },
    setPurchaseDetail({ commit, dispatch }, data) {
      commit("set_purchase_detail", data);
      dispatch("calculateTotaAmounts");
    },
    addItemPurchaseDetail({ commit, dispatch }, item) {
      commit("add_item_purchase_detail", item);
      dispatch("calculateTotaAmounts");
    },
    removeItemPurchaseDetail({ commit, dispatch }, index) {
      commit("remove_item_purchase_detail", index);
      dispatch("calculateTotaAmounts");
    },
    replaceItemPurchaseDetail({ commit, dispatch }, data) {
      commit("replace_item_purchase_detail", data);
      dispatch("calculateTotaAmounts");
    },
    clean_data({ commit }) {

      commit('set_clean_data')

      // commit("set_purchase_id", null);
      // commit("set_supplier_id", null);
      // commit("set_register_date", null);
      // commit("set_register_date_emision", null);
      // commit("set_tipo_cambio", null);
      // commit("set_tipo_moneda", null);
      // commit("set_sale_order", null);
      // commit("set_credit_purchase", false);
      // commit("set_date_payment", null);
      // commit("set_type_document", null);
      // commit("set_serie", null);
      // commit("set_correlative", null);
      // commit("set_storehouse_id", null);
      // commit("set_origin_id", null);
      // commit("set_till_id", null);
      // commit("set_account_id", null);
    },
    calculateTotaAmounts({ state, commit }) {
      let quantity = 0;
      let discount = 0;
      let subtotal = 0;
      let igv = 0;
      let total = 0;
      let data = state.purchase_detail;
      if (data) {
        data.forEach((element) => {
          quantity = quantity + parseFloat(element.quantity);
          discount = discount + parseFloat(element.discount);
          subtotal = subtotal + parseFloat(element.total);
          igv = igv + parseFloat(element.igv);
        });
      }
      total = subtotal + igv;

      quantity = Math.round(quantity * 100) / 100;
      discount = Math.round(discount * 100) / 100;
      subtotal = Math.round(subtotal * 100) / 100;
      igv = Math.round(igv * 100) / 100;
      total = Math.round(total * 100) / 100;

      const value = {
        set_subtotal: subtotal,
        set_discount: discount,
        set_igv : igv,
        set_total: total
      }

      commit('set_calculate_total_amount', value)

      // commit("set_subtotal", subtotal);
      // commit("set_discount", discount);
      // commit("set_igv", igv);
      // commit("set_total", total);
    },
    async storePurchase({ state, dispatch }) {
      let purchase = {
        supplier_id: state.supplier_id,
        register_date: state.register_date,
        register_date_emision: state.register_date_emision,
        tipo_cambio: state.tipo_cambio,
        tipo_moneda: state.tipo_moneda,
        sale_order: state.sale_order,
        type_document: state.type_document,
        serie: state.serie,
        correlative: state.correlative,
        discount: state.discount,
        subtotal: state.subtotal,
        igv: state.igv,
        total: state.total,
        credit_purchase: state.credit_purchase,
        date_payment: state.date_payment,
        detail: state.purchase_detail,
        storehouse_id: state.storehouse_id,
        origin_id: state.origin_id,
        account_id: state.account_id,
        till_id: state.till_id,
      };
      //   console.log("this next date is object purchase");
      //   console.log(purchase);

      return await PurchasesApi.store(purchase)
        .then((response) => {
          if (response.status === 203) {
            dispatch(
              "notifications/store_notification",
              {
                type: "error",
                message:
                  response.data.message || "Error al registrar la solicitud",
              },
              { root: true }
            );
          } else {
            dispatch(
              "notifications/store_notification",
              {
                type: "success",
                message: "El registro de compra se realizó de forma correcta.",
              },
              { root: true }
            );
          }
          dispatch("clean_data");
        })
        .catch((error) => {
          if (error.response?.status === 401) return null
          dispatch(
            "notifications/store_notification",
            {
              type: "error",
              message:
                "Ocurrió un error al registrar compra, vuelva a intentarlo.",
            },
            { root: true }
          );
        });
    },
    async delete({ dispatch }, purchase) {
      return await PurchasesApi.delete(purchase)
        .then((response) => {
          console.log(response);
          if (response.status == 203) {
            dispatch(
              "notifications/store_notification",
              {
                type: "error",
                message:
                  response.data.error ||
                  "Ocurrió un error al eliminar, vuelva a intentarlo.",
              },
              { root: true }
            );
          } else {
            dispatch(
              "notifications/store_notification",
              {
                type: "success",
                message: "La compra fue eliminada",
              },
              { root: true }
            );
          }
        })
        .catch((error) => {
          if (error.response?.status === 401) return null
          dispatch(
            "notifications/store_notification",
            {
              type: "error",
              message: "Ocurrió un error al eliminar, vuelva a intentarlo.",
            },
            { root: true }
          );
        });
    },
    selectPurchaseToEdit({ commit, dispatch }, purchase) {
      const data = {
        set_purchase_id: purchase.id,
        set_supplier_id: purchase.supplier_id,
        set_register_date: purchase.register_date,
        set_register_date_emision: purchase.register_date_emision,
        set_sale_order: null,
        set_credit_purchase: purchase.credit_purchase,
        set_date_payment: purchase.date_payment,
        set_type_document: purchase.type_document,
        set_serie: purchase.serie,
        set_correlative: purchase.correlative,
        set_purchase_detail: purchase.detail,
        set_subtotal: parseFloat(purchase.subtotal),
        set_discount: parseFloat(purchase.discount),
        set_igv: parseFloat(purchase.igv),
        set_total: parseFloat(purchase.total),
        set_storehouse_id: purchase.storehouse_id,
        set_origin_id: purchase.origin_id,
        set_account_id: purchase.account_id,
        set_till_id: purchase.till_id
      }
      commit('set_select_purchase_to_edit', data)

      // commit("set_purchase_id", purchase.id);
      // commit("set_supplier_id", purchase.supplier_id);
      // commit("set_register_date", purchase.register_date);
      // commit("set_register_date_emision", purchase.register_date_emision);
      // commit("set_sale_order", null);
      // commit("set_credit_purchase", purchase.credit_purchase);
      // commit("set_date_payment", purchase.date_payment);
      // commit("set_type_document", purchase.type_document);
      // commit("set_serie", purchase.serie);
      // commit("set_correlative", purchase.correlative);
      // commit("set_purchase_detail", purchase.detail);
      // commit("set_subtotal", parseFloat(purchase.subtotal));
      // commit("set_discount", parseFloat(purchase.discount));
      // commit("set_igv", parseFloat(purchase.igv));
      // commit("set_total", parseFloat(purchase.total));
      // commit("set_storehouse_id", purchase.storehouse_id);
      // commit("set_origin_id", purchase.origin_id);
      // commit("set_account_id", purchase.account_id);
      // commit("set_till_id", purchase.till_id);
    },
    async updatePurchase({ state, dispatch }) {
      let purchase = {
        id: state.purchase_id,
        supplier_id: state.supplier_id,
        register_date: state.register_date,
        register_date_emision: state.register_date_emision,
        sale_order: state.sale_order,
        type_document: state.type_document,
        serie: state.serie,
        correlative: state.correlative,
        discount: state.discount,
        subtotal: state.subtotal,
        igv: state.igv,
        total: state.total,
        credit_purchase: state.credit_purchase,
        date_payment: state.date_payment,
        detail: state.purchase_detail,
        origin_id: state.origin_id,
        account_id: state.account_id,
        till_id: state.till_id,
      };

      return await PurchasesApi.update(purchase)
        .then((response) => {
          dispatch(
            "notifications/store_notification",
            {
              type: "success",
              message: "La compra fue actualizada de forma correcta.",
            },
            { root: true }
          );
          dispatch("clean_data");
        })
        .catch((error) => {
          if (error.response?.status === 401) return null
          dispatch(
            "notifications/store_notification",
            {
              type: "error",
              message:
                "Ocurrió un error al actualizar compra, vuelva a intentarlo.",
            },
            { root: true }
          );
        });
    },
  },
};
